<template lang="pug">
  .component-driver-reservation-request
    .card
      .inner-content
        .row
          .column.shrink
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
              DriverReservationRequestButtons(:item="item")
          .column
            .label DRR{{item.id}}
              driver(:type="'onlyname'", :item="item.driver")
            .row
              .column
                .label Start
                .value {{item.start}}
            .row
              .column
                .label End
                .value {{item.end}}

          .column
            .row
              .column
                .label Passengers
                .value {{item.flags.passengers}}
            .row
              .column
                .label Request Completed
                .value
                  span.fa(:class='{"fa-times": item.reservation == null,"fa-check":item.reservation != null} ')
                  template(v-if="item.reservation !== null" )
            .row
              .column.shrink
                label Off road
                .value
                  span.fa(:class='{"fa-times":!item.flags.offroad,"fa-check":item.flags.offroad} ')
              .column.shrink
                template(v-if="item.flags.hasOwnProperty('luxury')" )
                  label Luxury
                  .value
                    span.fa(:class='{"fa-times":!item.flags.luxury,"fa-check":item.flags.luxury} ')

          .column
            .row
              .column
                .label Pickup
                .value PL{{item.pick_up.id}} {{item.pick_up.name}}
            .row
              .column
                .label Dropoff
                .value PL{{item.drop_off.id}} {{item.drop_off.name}}
                template(v-if="item.flags.hasOwnProperty('estimated_distance')" )
                  label Estimated distance
                  .value {{item.flags.estimated_distance}}
          .column
            .row
              .column
                .label Status
                .value {{item.status}}
                .value {{item.sub_status}}
            .row
              .column
                .label Request Date and Time
                .value {{item.created_at}}
                .label Request last update
                .value {{item.updated_at}}

            .row(v-if="item.deleted_at != null" )
              .column
                .label Request deleted at
                .value {{item.deleted_at}}
          .column.shrink
            router-link(v-if="item.reservation != null" :to="{name:'reservation', params:{id:item.reservation.id}}")
              i.fa.fa-angle-right.fa-3x.action

</template>

<script>
import CardN from '../structure/CardN'
import Dropdown from '../structure/foundation/Dropdown'
import Driver from "../backoffice/Driver.vue";
import DriverReservationRequestButtons from "../structure/ui/actions/DriverReservationRequestButtons.vue";

export default {
  name: 'DriverReservationRequest',
  components: {
    DriverReservationRequestButtons,
    Driver, Dropdown, CardN
  },

  props: ['item', 'driver']
}
</script>

<style lang="sass">
.component-driver-reservation-request
  .fa-check
    color: green

  .fa-times
    color: red
</style>



// WEBPACK FOOTER //
// DriverReservationRequest.vue?533e4fe6